// Admin portal client-side UX guard.
// SECURITY NOTE: this is UX-only. The real gate is server-side
// `[Authorize(Policy = "GlobalAdmin")]` registered in WebInterface/Program.cs.
// All admin API endpoints are protected by that policy regardless of what the SPA does.
// Bypassing this guard via DevTools only reveals an empty client shell — the API
// will reject any data request from a caller without the global-admin role.

import React from 'react';

export function AdminGuard({ auth, children }) {
    if (!auth) return null;

    if (!auth.isAuthenticated()) {
        auth.login();
        return (
            <div className="container mt-5">
                <p>Redirecting to the authentication service...</p>
            </div>
        );
    }

    if (!auth.hasRole('global-admin')) {
        // UX-friendly forbidden — server side will also deny if they try the API directly.
        return (
            <div className="container mt-5">
                <h2>Forbidden</h2>
                <p>Your account does not have global administrator access.</p>
            </div>
        );
    }

    return <>{children}</>;
}

export default AdminGuard;
